import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { NumericFormat } from 'react-number-format';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';

const data = [
  { month: 'Jan', lastYear: 10000, thisYear: 12000 },
  { month: 'Feb', lastYear: 11000, thisYear: 11500 },
  { month: 'Mar', lastYear: 13000, thisYear: 14000 },
  { month: 'Apr', lastYear: 12000, thisYear: 15000 },
  { month: 'May', lastYear: 15000, thisYear: 16000 },
  { month: 'Jun', lastYear: 17000, thisYear: 18000 },
];
// let totalLastYear =0;
// let totalThisYear = 0;
export default function MonthlyRevenueComparison({data, searchStartDate}) {
      const now= new Date(searchStartDate);
    // useEffect(() => {
    //   const index = now.getMonth();
    //   const tempJson = data[index];
    //   if(tempJson){
    //     totalThisYear=tempJson.amount;
    //     totalLastYear = tempJson.lastYearAmount;
    //   }
      


    // }, []);
  return (
    <Box sx={{ p: 3, background: '#fff', borderRadius: 2, boxShadow: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            Monthly Revenue (This Year vs Last Year)
          </Typography>
          <Typography variant="h4">
            <b style={{color:"#82ca9d"}}>
              <NumericFormat value={data[now.getMonth()]?.amount} thousandSeparator prefix={'$'} displayType="text"/>
            </b>
              &nbsp;vs&nbsp;
            <b style={{color:"#8884d8"}}>
              <NumericFormat value={data[now.getMonth()]?.lastYearAmount} thousandSeparator prefix={'$'} displayType="text"/>
            </b>
            </Typography> 
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data} margin={{ top: 20}}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis tickFormatter={(val) => `$${val}`} />
        <Tooltip />
        <Legend />
        <Bar dataKey="amount" fill="#82ca9d" name="This Year" />
        <Bar dataKey="lastYearAmount" fill="#8884d8" name="Last Year" />
      </BarChart>
    </ResponsiveContainer>
    </Box>
  );
}
